<script setup lang="ts">
import useModel from './../model/model'
import { VMapMarker, VMapZoom, VModal } from '@/shared/ui'
import {
  YMap,
  YMapControls,
  YMapDefaultFeaturesLayer,
  YMapDefaultSchemeLayer,
  YMapListener,
  YMapMarker,
} from '@/shared/lib'
import { type PropType, ref, watch } from 'vue'

const props = defineProps({
  latitude: {
    type: Object as PropType<number | null>,
    required: true,
  },
  longitude: {
    type: Object as PropType<number | null>,
    required: true,
  },
})

const model = useModel()
const emits = defineEmits(['setCoords'])

/**
 * Значение для установки параметров карты
 */
const zoom = ref(12)
const center = ref([model.coords.longitude, model.coords.latitude])

/**
 * Задаем значения по умолчанию если
 * не переданы координаты
 */
watch(props, () => {
  model.setValue(props.latitude || 59.9343, props.longitude || 30.3351)
  center.value = [model.coords.longitude, model.coords.latitude]
})

/**
 * Обработка события перемещения объекта
 * @param event
 */
const dragMoveHandler = (event: number[]) => {
  model.coords.latitude = event[1]
  model.coords.longitude = event[0]
}

/**
 * Функция-обработчик выбора координат
 */
const setCoordsHandler = () => {
  emits('setCoords', { ...model.coords })
  model.open = false
  zoom.value = 12
}

/**
 * Функция обновления перемещения курсора
 * @param event
 */
const updateHandler = (event: any) => {
  zoom.value = event.location.zoom
  center.value = event.location.center
}

/**
 * Функция установки координат по клику
 * @param _
 * @param event
 */
const clickHandler = (_, event: any) => {
  model.coords.latitude = event.coordinates[1]
  model.coords.longitude = event.coordinates[0]
}
</script>

<template>
  <VModal :title="$t('itf.map_modal')" v-model="model.open" :width="1200">
    <YMap class="position_relative" :location="{ center, zoom }" :style="{ height: '60vh' }">
      <YMapDefaultSchemeLayer />
      <YMapDefaultFeaturesLayer />
      <YMapControls position="top left">
        <VMapZoom v-model="zoom" />
      </YMapControls>

      <YMapMarker
        :coordinates="[model.coords.longitude, model.coords.latitude]"
        :draggable="true"
        :onDragMove="dragMoveHandler"
      >
        <VMapMarker />
      </YMapMarker>

      <YMapListener @update="updateHandler" @click="clickHandler" />
    </YMap>

    <div class="form__btn_right mt-6">
      <VTextField :label="$t('itf.latitude')" v-model="model.coords.latitude" hide-details />
      <VTextField :label="$t('itf.longitude')" v-model="model.coords.longitude" hide-details />

      <VBtn color="default" variant="tonal" @click.prevent="model.open = false">{{
        $t('itf.cancel')
      }}</VBtn>
      <VBtn type="button" @click.prevent="setCoordsHandler">{{ $t('itf.set') }}</VBtn>
    </div>
  </VModal>
</template>
